// 应用版本信息
export const APP_VERSION = '1.0.0';

